var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column page-content text-left h-100 w-75 mx-auto"},[_c('h2',{staticClass:"text-lg text-gray-dark"},[_vm._v(" "+_vm._s(_vm.$t("messages.app.ui.your_session"))+" ")]),_c('SessionSidebar',{staticClass:"flex-grow-1 pb-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }